import { Navigate } from "react-router-dom";

function ProtectedRoute({children}) {
    const userId = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const expiryTime = localStorage.getItem("expiryTime");
    console.log("Checked...")
    if(!userId && !token) {
        return <Navigate to="/login" />
    }
    if (expiryTime) {
        const currentTime = new Date().getTime();
        if (expiryTime && currentTime > Number(expiryTime)) {
            localStorage.clear();
            alert("Session expired. Please login again.");
            return <Navigate to="/login" />
        }
    }
    return children;
}

export default ProtectedRoute;